<template>
  <b-container fluid>
    <b-row>
      <b-col lg="4">
        <iq-card body-class="iq-card-body pl-0 pr-0 pt-0">
          <template v-slot:default v-if="doctor">
            <div class="docter-details-block">
              <div class="doc-profile-bg bg-primary" style="height:150px;">
              </div>
              <div class="docter-profile text-center" v-if="doctor.profilePic">
                <b-img :src="doctor.profilePic" alt="profile-img" class="profile-pic" />
              </div>
              <div class="docter-profile text-center" v-else>
                <b-img :src="defaultProfilePic" alt="profile-img" class="profile-pic" />
              </div>
              <div class="text-center mt-3 pl-3 pr-3">
                <h4><b> {{ doctor.firstName }} {{ doctor.lastName }} </b></h4>
                <p>Doctor</p>
              </div>
              <hr>
              <ul class="doctoe-sedual d-flex align-items-center justify-content-between p-0 m-0">
                <li class="text-center">
                  <h3 class="counter" v-if="doctor.patients">{{ doctor.patients.length }}</h3>
                  <h3 class="counter" v-else>0</h3>
                  <span>Patients</span>
                </li>
              </ul>
            </div>
          </template>
        </iq-card>
        <iq-card body-class="iq-card-body">
          <template v-slot:default>
            <div class="iq-card-header d-flex justify-content-between">
              <div class="iq-header-title">
                <h4 class="card-title">Personal Information</h4>
              </div>
            </div>
            <div class="iq-card-body" v-if="doctor">
              <div class="about-info m-0 p-0">
                <div class="row">
                  <div class="col-4">First Name:</div>
                  <div class="col-8">{{ doctor.firstName }}</div>
                  <div class="col-4">Last Name:</div>
                  <div class="col-8">{{ doctor.lastName }}</div>
                  <div class="col-4">Email:</div>
                  <div class="col-8">{{ doctor.email }}</div>
                  <div class="col-4">Phone:</div>
                  <div class="col-8">{{ doctor.phoneNumber }}</div>
                  <div class="col-4">Position:</div>
                  <div class="col-8">{{ doctor.position }}</div>
                  <div class="col-4">Gender:</div>
                  <div class="col-8">{{ doctor.gender }}</div>
                  <div class="col-4">Address:</div>
                  <div class="col-8">{{ doctor.address }}</div>
                </div>
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="8">
        <b-row>
          <b-col md="12">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title">Specialities</h4>
              </template>
              <template v-slot:default>
                <div v-if="doctor && doctor.specialities && doctor.specialities.length">
                  <ul class="speciality-list m-0 p-0" v-for="speciality in doctor.specialities" :key="speciality.title">
                  <li class="d-flex mb-4 align-items-center">
                    <div class="user-img img-fluid"><a href="#" class="iq-bg-primary"><i class="ri-award-fill"></i></a></div>
                    <div class="media-support-info ml-3">
                      <h6>{{ speciality.title }}</h6>
                      <p class="mb-0">{{ speciality.description}}</p>
                    </div>
                    <button  @click="removeSpeciality(speciality)" class="btn removeBtn"><i class="fa fa-minus  mr-0" aria-hidden="true" /></button>
                  </li>
                </ul>
                </div>
                <div v-else>No specialities added.</div>
              </template>
            </iq-card>
          </b-col>
          <b-col md="12">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title">Notifications</h4>
              </template>
              <template v-slot:default>
              <div v-if="doctor && doctor.notifications">
                <ul class="iq-timeline">
                  <li>
                    <div class="timeline-dots border-success"></div>
                    <h6 class="">Dr. Joy Send you Photo</h6>
                    <small class="mt-1">23 November 2019</small>
                  </li>
                </ul>
              </div>
              <div v-else>No notifications.</div>
              </template>
            </iq-card>
          </b-col>
          <b-col md="12">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title">Device Registration</h4>
              </template>
              <template v-slot:headerAction>
              <button class="btn btn-icon" @click="addDeviceModalShow = !addDeviceModalShow">
                <i class="fa fa-plus  mr-0" aria-hidden="true" />
              </button>
            </template>
              <template v-slot:default>
                <b-modal title="New Device" v-model="addDeviceModalShow" okTitle="Register" no-close-on-backdrop
                @ok="registerNewDevice" @cancel="resetModal" :busy="registerDevicePending">
                <div>
                  <div class="form-group">
                            <label for="deviceId">Device ID:</label>
                            <input name="deviceId" class="form-control mb-0" :class="{'is-invalid': InvalidDeviceId}"
                                type="text" v-model="deviceId"/>
                                <span v-if="InvalidDeviceId">{{ InvalidDeviceId }}</span>
                          </div>
                        </div>
              </b-modal>
              <div v-if="doctor && doctor.devices && doctor.devices.length" class="d-flex justify-content-end">
                <div class="product table-responsive" v-if="devices">
                     <table class="table table-borderless mt-0">
                      <thead>
                          <tr class="text-muted">
                              <th width="40%">Device Image</th>
                              <th width="60%">Device ID</th>
                          </tr>
                      </thead>
                        <tbody>
                           <tr v-for="device in doctor.devices" :key="device">
                              <td width="40%">
                                 <img class="rounded " v-if="getDeviceTypeById(device) === 'Glove'" src="../../assets/images/glove.png" width="60">
                                 <img class="rounded" v-if="getDeviceTypeById(device) === 'Knee Brace'" src="../../assets/images/knee_sleeve.png" width="60">
                                 <img class="rounded" v-if="getDeviceTypeById(device) === 'Neat'" src="../../assets/images/neat.png" width="60">
                                 <img class="rounded" v-if="getDeviceTypeById(device) === 'Pants'" src="../../assets/images/knee_sleeve.png" width="60">
                                 <img class="rounded" v-if="getDeviceTypeById(device) === 'Band'" src="../../assets/images/band.jpg" width="60">
                              </td>
                              <td width="40%">
                                 <span class="text">{{ device }}</span>
                              </td>
                              <td width="20%">
                                 <button class="btn btn-primary btn-text" @click="removeDevice(device)">Remove</button>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
              </div>
              <div v-else>No registered devices.</div>
              </template>
            </iq-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { xray } from '../../config/pluginInit'
import firebaseService from '../../../firebase'
import { onMounted, ref, watch } from 'vue'
import getDocument from '../../services/getDocument'
import getCollection from '../../services/getCollection'
import { updateDocument } from '../../services/useDocument'
import _ from 'lodash'
import { arrayRemove, arrayUnion } from '@firebase/firestore'

export default {
  name: 'ProfileView',
  mounted () {
    xray.index()
  },
  setup () {
    const firebaseDoctor = firebaseService.firebaseAuth.currentUser
    const doctor = ref(null)
    const defaultProfilePic = require('../../assets/images/user/11.png')

    const { document } = getDocument('doctors', firebaseDoctor.uid)
    const localStorageDoctorKey = `doctor${firebaseDoctor.uid}`

    watch((document), (newDocument) => {
      if (!localStorage.getItem(localStorageDoctorKey) ||
      (localStorage.getItem(localStorageDoctorKey) && !_.isEqual(JSON.parse(localStorage.getItem(localStorageDoctorKey)),
        JSON.parse(JSON.stringify(newDocument))))) {
        localStorage.setItem(localStorageDoctorKey, JSON.stringify(newDocument))
        updateDoctorInfo()
      }
    })

    // If doctor's data are stored in cache, fetch them
    onMounted(() => {
      if (localStorage.getItem(localStorageDoctorKey)) {
        updateDoctorInfo()
      }
    })

    const updateDoctorInfo = () => {
      doctor.value = JSON.parse(localStorage.getItem(localStorageDoctorKey))
      doctor.value.phoneNumber = firebaseDoctor.phoneNumber
      doctor.value.email = firebaseDoctor.email
    }

    // Remove specialities
    const { handlelUpdate } = updateDocument('doctors', firebaseDoctor.uid)

    const removeSpeciality = async (speciality) => {
      await handlelUpdate({ specialities: arrayRemove(speciality) })
    }

    // Register new devices
    const addDeviceModalShow = ref(false)
    const deviceId = ref(null)
    const InvalidDeviceId = ref(false)
    const registerDevicePending = ref(false)
    const { documents: devices } = getCollection('devices')

    const registerNewDevice = async (e) => {
      e.preventDefault()
      InvalidDeviceId.value = null
      if (!deviceId.value || !deviceId.value.length) {
        InvalidDeviceId.value = 'No deivce ID.'
        return
      }
      if (doctor.value.devices && doctor.value.devices.includes(deviceId.value)) {
        InvalidDeviceId.value = 'This device has been registered.'
        return
      }
      if (!devices.value.find((device) => device.id === deviceId.value)) {
        InvalidDeviceId.value = 'This device ID does not exist.'
        return
      }
      registerDevicePending.value = true
      await handlelUpdate({ devices: arrayUnion(deviceId.value) })
      addDeviceModalShow.value = false
      registerDevicePending.value = false
      deviceId.value = null
      InvalidDeviceId.value = null
    }

    const resetModal = () => {
      deviceId.value = null
      registerDevicePending.value = false
      InvalidDeviceId.value = null
    }

    const getDeviceTypeById = (id) => {
      return (devices.value.find((device) => device.id === id)).deviceType
    }

    // Remove device
    const removeDevice = async (id) => {
      await handlelUpdate({ devices: arrayRemove(id) })
    }

    return {
      doctor,
      defaultProfilePic,
      removeSpeciality,
      addDeviceModalShow,
      registerNewDevice,
      resetModal,
      InvalidDeviceId,
      registerDevicePending,
      deviceId,
      devices,
      getDeviceTypeById,
      removeDevice
    }
  }
}
</script>

<style scoped>
  .profile-pic{
    height: 130px; width: 130px; line-height: 130px; font-size: 1.6rem;
    margin: auto;
  }

  .removeBtn {
    color: #b583bc;
  }

  .btn.btn-icon {
      color: #b583bc;
  }

  .btn-text {
    font-size: 12px;
  }

</style>
